import React from 'react';

const Pennsylvania = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Pennsylvania Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Seller’s Property Disclosure Statement: Required by law.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Lead-Based Paint Disclosure{' '}
          </span>
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Pennsylvania-Sellers-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Property Disclosure Statement{' '}
          </span>
          – Property Disclosure Statement mentioning any known material defects
          that could affect the buyer's decision to purchase.
        </li>
      </ol>
    </div>
  );
};

export default Pennsylvania;
